import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../../redux/types'

export function RoleSelect({ roleId, handleInputChange }: any) {
  const { t } = useTranslation(['global'])

  const { roles, rolehierarchy } = useSelector((state: IRootState) => state.role)

  return (
    <FormControl fullWidth variant="filled">
      <InputLabel shrink={true} id="lbl-roles">
        {`${t('rol')} *`}
      </InputLabel>
      <Select value={roleId} labelId="lbl-roles" id="select-roles" fullWidth label="rol" onChange={e => handleInputChange('role_id', e.target.value)}>
        {roles.map((role: any) => {
          if (rolehierarchy.includes(role.id) && role.id !== 4)
            return (
              <MenuItem key={role.id} value={role.id}>
                {role.name}
              </MenuItem>
            )
        })}
      </Select>
    </FormControl>
  )
}
